"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rand = void 0;
function rand(list) {
    return list[Math.floor(Math.random() * list.length)];
}
exports.rand = rand;
